var map = {
	"./Babylonian.sol": 1842,
	"./DiscoLP.sol": 1843,
	"./DiscoLPFactory.sol": 1844,
	"./Dummy.sol": 1845,
	"./DummyLevel.sol": 1846,
	"./FakerDAO.sol": 1847,
	"./FakerDAOFactory.sol": 1848,
	"./Instance.sol": 1849,
	"./InstanceFactory.sol": 1850,
	"./MainChef.sol": 1851,
	"./MainChefFactory.sol": 1852,
	"./MayTheForceBeWithYou.sol": 1853,
	"./MayTheForceBeWithYouFactory.sol": 1854,
	"./P2PSwapper.sol": 1855,
	"./P2PSwapperFactory.sol": 1856,
	"./base/Level-05.sol": 1857,
	"./base/Level.sol": 1858
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1841;


//////////////////
// WEBPACK FOOTER
// ./contracts/levels ^\.\/.*$
// module id = 1841
// module chunks = 0